import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { Row } from 'antd';

/* replace-start-value = import { getChildrenToRender } from './utils'; */
import { getChildrenToRender } from '../../utils';
/* replace-end-value */
/* replace-start */
import './index.less';
/* replace-end */

function Feature19(props) {
  const { dataSource, isMobile, ...tagProps } = props;
  const { blockWrapper, titleWrapper } = dataSource;
  const childrenToRender = blockWrapper.children.map((item, i) => (
    <div
      {...item}
      key={i.toString()}
      /* replace-start */
      data-edit="Col"
    /* replace-end */
    >
      <a
        {...item.children}
        /* replace-start */
        data-edit="linkA"
      /* replace-end */
      >
        <div>
          {item.children.children.map(getChildrenToRender)}
        </div>
      </a>
    </div>
  ));
  const childrenToRenderImg = dataSource.img.children.map((item) => {
    return (
      <div
        key={item.name}
        {...item}
        /* replace-start */
        data-edit="Col"
        /* replace-end */
      >
        <div {...item.children.wrapper}>
          <span {...item.children.img}>
            <img src={item.children.img.children} alt="img" />
          </span>
        </div>
      </div>
    );
  });
  return (
    <div
      {...tagProps}
      {...dataSource.wrapper}
    >
      <div {...dataSource.page}>
        <div
          {...dataSource.titleWrapper}
          /* replace-start */
          data-edit="titleWrapper"
        /* replace-end */
        >
          {titleWrapper.children.map(getChildrenToRender)}
        </div>
        <OverPack {...dataSource.OverPack}>
          <QueueAnim
            key="queue"
            type="bottom"
            leaveReverse
            interval={50}
            component={Row}
            {...blockWrapper}
            /* replace-start */
            data-edit="Row"
          /* replace-end */
          >
            {childrenToRender}
          </QueueAnim>
        </OverPack>
        <OverPack
          className="content-template"
          {...dataSource.OverPack}
        >
          {childrenToRenderImg}
        </OverPack>
      </div>
    </div>
  );
}

export default Feature19;
